import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/logo.svg'
import _imports_1 from '@/assets/images/white-logo.svg'


const _hoisted_1 = { class: "container mw-1685 position-relative" }
const _hoisted_2 = { class: "collapse navbar-collapse" }
const _hoisted_3 = { class: "navbar-nav ms-auto" }
const _hoisted_4 = { class: "nav-item dropdown" }
const _hoisted_5 = { class: "dropdown-menu" }
const _hoisted_6 = { class: "nav-item dropdown" }
const _hoisted_7 = { class: "dropdown-menu" }
const _hoisted_8 = { class: "nav-item dropdown" }
const _hoisted_9 = { class: "dropdown-menu" }
const _hoisted_10 = { class: "dropdown-menu" }
const _hoisted_11 = { class: "nav-item dropdown" }
const _hoisted_12 = { class: "dropdown-menu" }
const _hoisted_13 = { class: "nav-item dropdown" }
const _hoisted_14 = { class: "dropdown-menu" }
const _hoisted_15 = { class: "nav-item dropdown" }
const _hoisted_16 = { class: "nav-item dropdown" }
const _hoisted_17 = { class: "d-flex ps-0 mb-0 list-unstyled justify-content-end align-items-center others-options" }
const _hoisted_18 = { class: "d-xl-none" }
const _hoisted_19 = { class: "d-none d-xl-block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("nav", {
    class: _normalizeClass([
      'navbar navbar-expand-lg bg-white p-0 navbar-style-three',
      { sticky: _ctx.isSticky },
    ])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_RouterLink, {
        class: "navbar-brand",
        to: "/"
      }, {
        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
          _createElementVNode("img", {
            src: _imports_0,
            class: "main-logo",
            alt: "white-logo"
          }, null, -1),
          _createElementVNode("img", {
            src: _imports_1,
            class: "white-logo d-none",
            alt: "white-logo"
          }, null, -1)
        ]))]),
        _: 1
      }),
      _createElementVNode("a", {
        class: "navbar-toggler",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.responsiveNavbar && _ctx.stateStoreInstance.responsiveNavbar(...args)))
      }, [...(_cache[4] || (_cache[4] = [
        _createElementVNode("span", { class: "burger-menu" }, [
          _createElementVNode("span", { class: "top-bar" }),
          _createElementVNode("span", { class: "middle-bar" }),
          _createElementVNode("span", { class: "bottom-bar" })
        ], -1)
      ]))]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("ul", _hoisted_3, [
          _createElementVNode("li", _hoisted_4, [
            _cache[11] || (_cache[11] = _createElementVNode("a", {
              class: "nav-link dropdown-toggle",
              href: "#",
              role: "button",
              "data-bs-toggle": "dropdown",
              "aria-expanded": "false"
            }, " الرئيسية ", -1)),
            _createElementVNode("ul", _hoisted_5, [
              _createElementVNode("li", null, [
                _createVNode(_component_RouterLink, {
                  class: "dropdown-item",
                  to: "/"
                }, {
                  default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                    _createTextVNode(" مزود خدمة الإنترنت (ISP) ", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_RouterLink, {
                  class: "dropdown-item",
                  to: "/iptv-service"
                }, {
                  default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                    _createTextVNode(" خدمة IPTV ", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_RouterLink, {
                  class: "dropdown-item",
                  to: "/isp-broadband"
                }, {
                  default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                    _createTextVNode(" إنترنت النطاق العريض (Broadband) ", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_RouterLink, {
                  class: "dropdown-item",
                  to: "/ott-platform"
                }, {
                  default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                    _createTextVNode(" منصة OTT ", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_RouterLink, {
                  class: "dropdown-item",
                  to: "/movie-home"
                }, {
                  default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                    _createTextVNode(" رئيسية الأفلام ", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_RouterLink, {
                  class: "dropdown-item",
                  to: "/satellite-internet"
                }, {
                  default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                    _createTextVNode(" الإنترنت الفضائي ", -1)
                  ]))]),
                  _: 1
                })
              ])
            ])
          ]),
          _createElementVNode("li", _hoisted_6, [
            _cache[14] || (_cache[14] = _createElementVNode("a", {
              class: "nav-link dropdown-toggle",
              href: "#",
              role: "button",
              "data-bs-toggle": "dropdown",
              "aria-expanded": "false"
            }, " الخدمات ", -1)),
            _createElementVNode("ul", _hoisted_7, [
              _createElementVNode("li", null, [
                _createVNode(_component_RouterLink, {
                  class: "dropdown-item",
                  to: "/services"
                }, {
                  default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                    _createTextVNode(" الخدمات ", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_RouterLink, {
                  class: "dropdown-item",
                  to: "/services-details"
                }, {
                  default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                    _createTextVNode(" تفاصيل الخدمات ", -1)
                  ]))]),
                  _: 1
                })
              ])
            ])
          ]),
          _createElementVNode("li", _hoisted_8, [
            _cache[28] || (_cache[28] = _createElementVNode("a", {
              class: "nav-link dropdown-toggle",
              href: "#",
              role: "button",
              "data-bs-toggle": "dropdown",
              "aria-expanded": "false"
            }, " الصفحات ", -1)),
            _createElementVNode("ul", _hoisted_9, [
              _createElementVNode("li", null, [
                _createVNode(_component_RouterLink, {
                  class: "dropdown-item",
                  to: "/about-us"
                }, {
                  default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                    _createTextVNode(" من نحن ", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_RouterLink, {
                  class: "dropdown-item",
                  to: "/testimonials"
                }, {
                  default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                    _createTextVNode(" آراء العملاء ", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_RouterLink, {
                  class: "dropdown-item",
                  to: "/pricing-plan"
                }, {
                  default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                    _createTextVNode(" خطة الأسعار ", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_RouterLink, {
                  class: "dropdown-item",
                  to: "/channel-list"
                }, {
                  default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                    _createTextVNode(" قائمة القنوات ", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_RouterLink, {
                  class: "dropdown-item",
                  to: "/faq"
                }, {
                  default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                    _createTextVNode(" الأسئلة الشائعة ", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _cache[25] || (_cache[25] = _createElementVNode("a", {
                  class: "dropdown-item sub-dropdown dropdown-toggle",
                  href: "#",
                  role: "button",
                  "data-bs-toggle": "dropdown",
                  "aria-expanded": "false"
                }, " التوثيق وتفعيل الحساب ", -1)),
                _createElementVNode("ul", _hoisted_10, [
                  _createElementVNode("li", null, [
                    _createVNode(_component_RouterLink, {
                      class: "dropdown-item",
                      to: "/login-register"
                    }, {
                      default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                        _createTextVNode(" تسجيل الدخول / التسجيل ", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_RouterLink, {
                      class: "dropdown-item",
                      to: "/login"
                    }, {
                      default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                        _createTextVNode(" تسجيل الدخول ", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_RouterLink, {
                      class: "dropdown-item",
                      to: "/register"
                    }, {
                      default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                        _createTextVNode(" حساب جديد ", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_RouterLink, {
                      class: "dropdown-item",
                      to: "/change-password"
                    }, {
                      default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                        _createTextVNode(" تغيير كلمة المرور ", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_RouterLink, {
                      class: "dropdown-item",
                      to: "/forgot-password"
                    }, {
                      default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                        _createTextVNode(" نسيت كلمة المرور ", -1)
                      ]))]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_RouterLink, {
                  class: "dropdown-item",
                  to: "/privacy-policy"
                }, {
                  default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                    _createTextVNode(" سياسة الخصوصية ", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_RouterLink, {
                  class: "dropdown-item",
                  to: "/terms-conditions"
                }, {
                  default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                    _createTextVNode(" الشروط والأحكام ", -1)
                  ]))]),
                  _: 1
                })
              ])
            ])
          ]),
          _createElementVNode("li", _hoisted_11, [
            _cache[35] || (_cache[35] = _createElementVNode("a", {
              class: "nav-link dropdown-toggle",
              href: "#",
              role: "button",
              "data-bs-toggle": "dropdown",
              "aria-expanded": "false"
            }, " المتجر ", -1)),
            _createElementVNode("ul", _hoisted_12, [
              _createElementVNode("li", null, [
                _createVNode(_component_RouterLink, {
                  class: "dropdown-item",
                  to: "/products"
                }, {
                  default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                    _createTextVNode(" المنتجات ", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_RouterLink, {
                  class: "dropdown-item",
                  to: "/product-details"
                }, {
                  default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                    _createTextVNode(" تفاصيل المنتج ", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_RouterLink, {
                  class: "dropdown-item",
                  to: "/cart"
                }, {
                  default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
                    _createTextVNode(" سلة المشتريات ", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_RouterLink, {
                  class: "dropdown-item",
                  to: "/checkout"
                }, {
                  default: _withCtx(() => [...(_cache[32] || (_cache[32] = [
                    _createTextVNode(" إتمام الطلب ", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_RouterLink, {
                  class: "dropdown-item",
                  to: "/pay-bill"
                }, {
                  default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
                    _createTextVNode(" دفع الفاتورة ", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_RouterLink, {
                  class: "dropdown-item",
                  to: "/pay-bill-pin"
                }, {
                  default: _withCtx(() => [...(_cache[34] || (_cache[34] = [
                    _createTextVNode(" رمز دفع الفاتورة (PIN) ", -1)
                  ]))]),
                  _: 1
                })
              ])
            ])
          ]),
          _createElementVNode("li", _hoisted_13, [
            _cache[41] || (_cache[41] = _createElementVNode("a", {
              class: "nav-link dropdown-toggle",
              href: "#",
              role: "button",
              "data-bs-toggle": "dropdown",
              "aria-expanded": "false"
            }, " المدونة ", -1)),
            _createElementVNode("ul", _hoisted_14, [
              _createElementVNode("li", null, [
                _createVNode(_component_RouterLink, {
                  class: "dropdown-item",
                  to: "/blog"
                }, {
                  default: _withCtx(() => [...(_cache[36] || (_cache[36] = [
                    _createTextVNode(" المدونة ", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_RouterLink, {
                  class: "dropdown-item",
                  to: "/blog-details"
                }, {
                  default: _withCtx(() => [...(_cache[37] || (_cache[37] = [
                    _createTextVNode(" تفاصيل المقال ", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_RouterLink, {
                  class: "dropdown-item",
                  to: "/tags"
                }, {
                  default: _withCtx(() => [...(_cache[38] || (_cache[38] = [
                    _createTextVNode(" الأوسام ", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_RouterLink, {
                  class: "dropdown-item",
                  to: "/categories"
                }, {
                  default: _withCtx(() => [...(_cache[39] || (_cache[39] = [
                    _createTextVNode(" التصنيفات ", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_RouterLink, {
                  class: "dropdown-item",
                  to: "/author"
                }, {
                  default: _withCtx(() => [...(_cache[40] || (_cache[40] = [
                    _createTextVNode(" الكاتب ", -1)
                  ]))]),
                  _: 1
                })
              ])
            ])
          ]),
          _createElementVNode("li", _hoisted_15, [
            _createVNode(_component_RouterLink, {
              class: "nav-link",
              to: "/pricing-plan"
            }, {
              default: _withCtx(() => [...(_cache[42] || (_cache[42] = [
                _createTextVNode(" خطة الأسعار ", -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_16, [
            _createVNode(_component_RouterLink, {
              class: "nav-link",
              to: "/contact-us"
            }, {
              default: _withCtx(() => [...(_cache[43] || (_cache[43] = [
                _createTextVNode(" اتصل بنا ", -1)
              ]))]),
              _: 1
            })
          ])
        ])
      ]),
      _createElementVNode("ul", _hoisted_17, [
        _createElementVNode("li", null, [
          _createElementVNode("a", {
            class: "cart icon",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.cartModal && _ctx.stateStoreInstance.cartModal(...args)))
          }, [
            _cache[44] || (_cache[44] = _createElementVNode("i", { class: "ti ti-shopping-cart" }, null, -1)),
            _createElementVNode("span", null, _toDisplayString(_ctx.cartStore.cartItemCount), 1)
          ])
        ]),
        _createElementVNode("li", null, [
          _createElementVNode("a", {
            class: "search icon",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.searchModal && _ctx.stateStoreInstance.searchModal(...args)))
          }, [...(_cache[45] || (_cache[45] = [
            _createElementVNode("i", { class: "ti ti-search" }, null, -1)
          ]))])
        ]),
        _createElementVNode("li", _hoisted_18, [
          _createVNode(_component_RouterLink, {
            to: "/register",
            class: "search icon"
          }, {
            default: _withCtx(() => [...(_cache[46] || (_cache[46] = [
              _createElementVNode("i", { class: "ti ti-user" }, null, -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_19, [
          _createVNode(_component_RouterLink, {
            to: "/pricing-plan",
            class: "btn"
          }, {
            default: _withCtx(() => [...(_cache[47] || (_cache[47] = [
              _createElementVNode("span", { class: "border-style" }, "ابدأ الآن", -1)
            ]))]),
            _: 1
          })
        ])
      ])
    ])
  ], 2))
}